// TrackerStartDate.tsx
import DateTimeForm from "@/components/form/DateTimeForm";
import { useState } from "react";
import { useInsertSharedAttributes } from "../api/insertSharedAttributes";
import { useUpdateSharedAttributes } from "../api/updateSharedAttributes";
import type { SharedAttributeJSON } from "../types";
import UpdateAllCheckbox from "./UpdateAllCheckbox";

type DateType = "reference_date" | "start_date" | "end_date";

interface Props {
	sharedAttributes?: SharedAttributeJSON;
	dateType: DateType;
}

const SharedAttributeDatePicker = ({ sharedAttributes, dateType }: Props) => {
	const { mutate: updateDates } = useUpdateSharedAttributes();
	const { mutate: insertDates } = useInsertSharedAttributes();
	const [updateAll, setUpdateAll] = useState(true);

	const hasAssociatedItems = Boolean(
		sharedAttributes?.events?.length ||
			sharedAttributes?.diaries?.length ||
			sharedAttributes?.trackers?.length,
	);

	const handleDateUpdate = (date: string | null) => {
		if (sharedAttributes?.shared_attribute_id) {
			if (updateAll) {
				updateDates({
					shared_attribute_id: sharedAttributes.shared_attribute_id,
					[dateType]: date,
				});
			} else {
				insertDates({
					[dateType]: date,
				});
			}
		} else {
			insertDates({
				[dateType]: date,
			});
		}
	};

	return (
		<div className="space-y-4">
			<DateTimeForm
				initialDate={sharedAttributes?.[dateType] ?? null}
				onSubmit={handleDateUpdate}
				submitButtonText="Save"
			/>
			{hasAssociatedItems && sharedAttributes && (
				<UpdateAllCheckbox checked={updateAll} onCheckedChange={setUpdateAll} />
			)}
		</div>
	);
};

export default SharedAttributeDatePicker;
